// extracted by mini-css-extract-plugin
export var fullHeightState = "_2d-7";
export var headerCell = "_2d-1";
export var loadingStateCell = "_2d-4";
export var rowWrapper = "_2d-3";
export var standaloneTable = "_2d-8";
export var standaloneTableWithBodyFill = "_2d-9";
export var stateCell = "_2d-5";
export var table = "_2d-0";
export var tableBodyFiller = "_2d-6";
export var white = "_2d-2";